<app-shared-ranking-classif
    [rankingId]="rankingId"
></app-shared-ranking-classif>
